import WidgetBox from "components/elements/WidgetBox/widget-box";
import PageHeader from "components/layout/PageHeader";
import { LoansTable } from "./loans-table";

export function Loans() {
	return (
		<>
			<PageHeader title="Loans" />
			<WidgetBox>
				<LoansTable />
			</WidgetBox>
		</>
	);
}
